export const ApiEndpoint = {
    users: '/users/',
    assetTypes: '/asset_types/',
    boundaries: '/boundaries/',
    bridgeCrossings: '/bridge_crossings/',
    cloudfrontAuth: '/cloudfront_auth/',
    coolRooms: '/cool_rooms/',
    dams: '/dams/',
    devices: '/yarn_devices/',
    diagnosticSnapshots: '/snapshots/diagnostic_snapshots/',
    erosionAreas: '/erosion_areas/',
    fences: '/fences/',
    firmwareSnapshots: '/snapshots/firmware_snapshots/',
    gasbotDevices: '/gasbot_devices/',
    gasbotLevelSnapshots: '/snapshots/gasbot_level_snapshots/',
    gates: '/gates/',
    heartbeatSnapshots: '/snapshots/heartbeat_snapshots/',
    herdSnapshots: '/snapshots/herd_snapshots/',
    herds: '/herds/',
    houses: '/houses/',
    imageSnapshots: '/snapshots/image_snapshots/',
    invitations: '/invites/',
    levelSnapshots: '/snapshots/level_snapshots/',
    locationSnapshots: '/snapshots/location_snapshots/',
    networkSnapshots: '/snapshots/network_snapshots/',
    notes: '/notes/',
    paddocks: '/paddocks/',
    powerSnapshots: '/snapshots/power_snapshots/',
    protagAnimalSnapshots: '/snapshots/protag_animal_snapshots/',
    protagAnimals: '/protag_animals/',
    sheds: '/sheds/',
    silos: '/silos/',
    farms: '/farms/',
    tanks: '/tanks/',
    taskCategories: '/task_categories/',
    tasks: '/tasks/',
    temperatureSnapshots: '/snapshots/temperature_snapshots/',
    token: '/auth/api-token-auth/',
    troughs: '/troughs/',
    weatherSnapshots: '/snapshots/weather_snapshots/',
    vegetation: '/vegetation/',
    waterways: '/waterways/',
    yards: '/yards/',

    /** For Jest tests */
    test: '/pineapples/',
} as const;
